<template>
  <div>
    <a-modal
      :title="audit ? '付款审批' : '付款申请详情'"
      :visible="is_show"
      width="60%"
      @cancel="is_show = false"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button type="primary" @click="downloadData" style="float: left"> 导出 </a-button>
        <a-button key="back" @click="is_show = false"> 取消 </a-button>
        <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
        <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
      </template>
      <div ref="sadsada">
        <a-form-model :model="info" :label-col="labelCol" :wrapper-col="wrapperCol">
          <div class="title">
            <span>基本信息</span>
          </div>
          <div class="content">
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批标题"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.title }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="抄送人"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.ccName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批编号"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.paymentCode }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="标    题" class="model_span_form">
                  <span>{{ info.title }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="隶属公司" class="model_span_form">
                  <span>{{ info.subjectionCompanyName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="隶属部门" class="model_span_form">
                  <span>{{ info.subjectionDeptName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="关联审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <span v-for="(item, index) in info.associateApply" :key="index" class="auditItem">
                    <span @click="handelAudit(item)">{{ item.associateTitle }}</span>
                  </span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="款项类目" class="model_span_form">
                  <span>{{ payMentTypes[info.projectType] }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="项目名称" class="model_span_form">
                  <span>{{ info.projectName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="项目总金额" class="model_span_form">
                  <span>{{ info.projectMoney }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="项目编号" class="model_span_form">
                  <span>{{ info.projectCode }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="已付金额" class="model_span_form">
                  <span>{{ info.paidCount }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="本次付款总金额" class="model_span_form">
                  <span>{{ info.payCount }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="备注"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.remark }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="特殊备注"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.remarkSpec }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="账户类型" class="model_span_form">
                  <span>{{ info.accountTypeName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="户名" class="model_span_form">
                  <span>{{ info.name }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="账号" class="model_span_form">
                  <span>{{ info.accountNum }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8" v-if="info.accountType == 2 || info.accountType == 3">
                <a-form-model-item label="开户行" class="model_span_form">
                  <span>{{ info.bank }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="info.accountType == 3">
                <a-form-model-item label="地址" class="model_span_form">
                  <span>{{ info.province }}{{ info.city }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="info.accountType == 3">
                <a-form-model-item label="银行支行" class="model_span_form">
                  <span>{{ info.branchBank }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div
                    class="view_path"
                    @click="previewFile(item)"
                    v-for="(item, index) in info.attachment"
                    :key="index"
                  >
                    {{ item.name }}
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="报销凭证" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div
                    class="view_path_img"
                    v-for="(item, index) in info.vouchers"
                    :key="index"
                    style="display: flex; justify-content: space-between"
                  >
                    <div class="view_path_img_margin"></div>
                    <div class="view_path_img_center">
                      <img :src="item.imgUrl" @click="show_img(index, info.vouchers)" />
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <div v-for="(item, index) in info.paymentDetails" :key="index">
            <div class="title">
              <span>付款明细{{ index + 1 }}</span>
            </div>
            <div class="content">
              <a-row>
                <a-col :span="8">
                  <a-form-model-item label="本次支付金额" class="model_span_form">
                    <span>{{ item.thisPayment }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item label="电子发票" class="model_span_form">
                    <span>{{ item.invoice }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="8">
                  <a-form-model-item label="费用明细" class="model_span_form">
                    <span>{{ item.remark }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </div>
          <div class="title" v-if="!audit && recordNumber == 1">
            <span>审批记录</span>
          </div>
          <div class="content" v-if="!audit && recordNumber == 1">
            <auditModel ref="auditModel"></auditModel>
          </div>
          <!-- <a-row>
					<a-col :span="12" v-if="audit">
						<a-form-model-item label="审批意见" style="margin-top: 25px">
							<a-textarea placeholder="请输入" v-model="comment" :auto-size="{ minRows: 2, maxRows: 6 }" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12" v-if="record.comment != undefined">
						<a-form-model-item label="审批意见" style="margin-top: 25px">
							{{ record.comment }}
						</a-form-model-item>
					</a-col>
				</a-row> -->
        </a-form-model>
      </div>
      <preview ref="preview" />
      <!-- 撤销提示 -->
      <a-modal
        v-model="is_revocation"
        :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
        on-ok="handleOkReason"
      >
        <template slot="footer">
          <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
            驳回
          </a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
            通过
          </a-button>
        </template>
        <a-textarea placeholder="请输入原因" v-model="comment" />
      </a-modal>
    </a-modal>
  </div>
</template>
<script>
import { downLoadPdf  } from '@/utils/index'
import auditModel from './audit.vue'
import { download_file_java } from '@/utils/request'
import { resolveBlob } from '@/utils/index'
import { axios } from '@/utils/request'
import { previewFileLists } from '@/utils/preview.js'
import { payment_apply_get } from '@/api/financial'
import { act_task_audit, payment_apply_downlodPdf, modalMap } from '@/api/activiti'
import preview from '@/components/module/prview'
import Watermark from '../../../utils/watermark'
   const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
export default {
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    auditModel
  },
  data() {
    return {
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      is_show: false,
      info: {},
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 16,
      },
      record: null,
    }
  },
  activated() {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    	//导出
		downloadData() {
			downLoadPdf('/act/payment_apply/downlodPdf?businessKey=' + this.record.businessKey,)
    },
    handelAudit(item) {
      const modal = modalMap[item.associateTypes]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: item.associateApply,
      })
    }, //预览文件
    async previewFile(file) {
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },

    // 		//预览文件
    // 		previewFile(file) {
    // 			    let path = '/' + file.url.split('/')[0] + '/'
    //   let fileName = file.url.substring(file.url.indexOf('/') + 1)
    //   axios({
    //     url: `/file/file/download?bucketName=${file.types}&path=${path}&fileName=${fileName}`,
    //     method: 'post',
    //     responseType: 'blob', // 必须要写 // headers: { //  'Content-Type': 'application/json;charset=UTF-8' // }
    //   }).then((res) => {
    //     this.imgUrl = window.URL.createObjectURL(res)
    //     resolveBlob({
    //       data: res,
    //       headers: {
    //         'content-disposition': `attachment;filename=${fileName}`,
    //       },
    //     }) //新窗口打开，借用浏览器去打印
    //   }) // window.open(file.preUrl)
    //   //             },

    //   // console.log(file)
    //   // window.open(file.preUrl)
    // 			// console.log(file)
    // 			// window.open(file.preUrl)
    // 		},
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    },
    download() {
      payment_apply_downlodPdf({
        businessKey: this.record.businessKey,
      }).then((res) => {
         window.open(exportBaseUrl + '/file/download?path=' + res.data)
      })
    },
    show(record, type = null) {
      this.recordNumber = record.recordNumber
      this.record = record
      console.log(this.record)
      payment_apply_get(record.businessKey).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.info = res.data
        previewFileLists(this.info.attachment).then((res) => {
          this.info.attachment = res
        })
        this.is_show = true
        this.$nextTick(() => {
          Watermark.set('安联云管家', this.$refs.sadsada)
           if(!this.audit && this.recordNumber == 1) {
                 this.$refs.auditModel.show(record)
               }
        })
      })
    },
    //驳回
    reject(result_) {
      this.is_revocation = true
      this.comment = ''
      this.result = result_
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
          this.actTask()
        }
      } else if (this.result == 2) {
        this.actTask()
      }
    },
    actTask() {
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: this.result,
        businessKey: this.record.businessKey,
        comment: this.comment,
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.is_show = false
        this.is_revocation = false
      })
    },
    succeed() {},
  },
}
</script>
<style>
.auditItem2 {
  border-radius: 5px;
  background-color: #f8f8f8;
  margin-left: 10px;
  padding: 10px;
}
</style>
